import React, {Component} from 'react';
import './barexpiration.css';
import '../../css/styles.css'

interface IBarExpirationState {
  color: number,
  maxWidth: number,
  width: number
}

interface IBarExpirationProps {
  color: number,
  maxWidth: number,
  width: number
}
export default class BarExpiration extends Component <IBarExpirationProps, IBarExpirationState> {

  constructor (props?:any) {
    super(props);

    this.state = {
      color:0,
      maxWidth: 0,
      width: 0
    }
  }

  private getWidth(): string {
    const p:number = Math.floor(this.props.width*100/this.props.maxWidth);
    return `${p.toString()}%`
  }
  render(): React.ReactNode {
    const style = {
      width: this.getWidth(),
      backgroundColor:'#FBD603',
      color:'black'
    };
    return (
      <div className='yello-to-red-h-gradient shadow font-weight-bold' style={style}>{this.props.width.toString()}</div>
    );
  }
}